export enum ShipmentStatuses {
  /**
   * Отгружен
   */
  SHIPPED = 'shipped',

  /**
   * Не отгружен
   */
  NOT_SHIPPED = 'not_shipped',

  /**
   * Частично отгружен
   */
  PARTIALLY_SHIPPED = 'partially_shipped',
}

export const ShipmentStatusesTranslate: Record<string, string> = {
  [ShipmentStatuses.SHIPPED]: 'Отгружен',
  [ShipmentStatuses.NOT_SHIPPED]: 'Не отгружен',
  [ShipmentStatuses.PARTIALLY_SHIPPED]: 'Частично отгружен',
};
